import React from 'react';
import { formatCurrency } from '../../../helpers/formatCurrency';
import { getItemPrice } from './OfferItemRow';
import { CycleDiscountMap } from '../../Coupons/v2/_components/CycleDiscountMap';
import { ruleMatchesItem, ruleMatchesPlan } from '../../Coupons/v2/utils';

const dotStyle = {
  position: 'absolute',
  left: '-21px',
  top: '4px',
  width: '10px',
  height: '10px',
  borderRadius: '50%',
  background: 'var(--bg-brand-default)',
  border: 'var(--stroke-medium) solid var(--bg-neutral-layer01)',
  boxShadow: '0 0 0 1px var(--bg-brand-default)',
};

export function OrderSummaryCard({
  planName,
  planAmount,
  items,
  discountAmount,
  couponCode,
  couponRules = [],
  planId,
  getCycleTotal,
  finalTotal,
}) {
  const addonItems = items.filter((item) => item.itemId && item.item);
  const selectedItems = items.filter((item) => item.item);
  const cycleRules = couponRules.filter(
    (rule) =>
      ruleMatchesPlan(rule, planId) &&
      (rule.scope !== 'ITEM' ||
        selectedItems.some((item) => ruleMatchesItem(rule, item.item.id))),
  );

  return (
    <div className="jds-card" style={{ padding: 0 }}>
      <div className="d-flex justify-content-between align-items-center px-5 pt-5">
        <div>
          <h3 className="jds-title-sm">Detalhes da compra</h3>
          <small className="text-muted">
            Estimativa do 1º ciclo — o valor final é calculado pelo sistema.
          </small>
        </div>
        <i
          className="flaticon2-information icon-md text-muted"
          title="Resumo do que será cobrado do cliente"
        ></i>
      </div>

      <div className="px-5 py-5">
        <div
          style={{
            borderLeft:
              'var(--stroke-small) solid var(--border-neutral-default)',
            marginLeft: '5px',
            paddingLeft: '21px',
          }}
        >
          <div
            style={{
              position: 'relative',
              marginBottom: addonItems.length ? '20px' : 0,
            }}
          >
            <span style={dotStyle} />
            <div className="jds-title-xs mb-1">Plano</div>
            <div className="d-flex justify-content-between">
              <span className="text-muted">{planName}</span>
              <span>{formatCurrency(planAmount)}</span>
            </div>
          </div>

          {addonItems.length > 0 && (
            <div style={{ position: 'relative' }}>
              <span style={dotStyle} />
              <div className="jds-title-xs mb-1">Produtos</div>
              {addonItems.map((item) => (
                <div key={item.key} className="d-flex justify-content-between">
                  <span className="text-muted">
                    {item.item.name} | {item.quantity}x
                  </span>
                  <span>
                    {formatCurrency(getItemPrice(item.item) * item.quantity)}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>

        <hr className="jds-divider" />

        {discountAmount > 0 && (
          <div className="d-flex justify-content-between mb-2">
            <span className="text-muted">Desconto (cupom {couponCode})</span>
            <span style={{ color: 'var(--fg-error-strong)' }}>
              − {formatCurrency(discountAmount)}
            </span>
          </div>
        )}
        <div className="d-flex justify-content-between align-items-center">
          <span className="jds-title-xs">Total</span>
          <span className="jds-title-sm">{formatCurrency(finalTotal)}</span>
        </div>

        {cycleRules.length > 0 && (
          <>
            <hr className="jds-divider" />
            <h4 className="jds-title-xs mb-3">Descontos por ciclo</h4>
            <CycleDiscountMap
              rules={cycleRules}
              getCycleTotal={getCycleTotal}
            />
          </>
        )}
      </div>
    </div>
  );
}
